var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Slider',_vm._g(_vm._b({staticClass:"ts-slider",attrs:{"tooltip-class":"ts-slider-tooltip"}},'Slider',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }